import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import SurveyType from '../../surveyType';
import TextBoxWithTooltip from '../../textBoxWithTooltip';
import CustomButton from '../../customButton';
import { ReactComponent as ClockIcon } from '../../../../assets/icons/clock.svg';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginRight: spacing(2),
  },
  surveyTitle: {
    marginTop: spacing(3),
    marginBottom: spacing(2),
  },
  expiryWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  clockIcon: {
    marginTop: spacing(-0.5),
    marginRight: spacing(2),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 'auto',
  },
  fillSurveyButton: {
    marginLeft: spacing(-2),
  },
  fillSurveyButtonLabel: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  buttonIcon: {
    marginRight: 0,
    marginLeft: spacing(2),
  },
}));

const FillSurveyCard = ({ translations, survey = {}, onFillSurvey }) => {
  const classes = useStyles();
  const { id, title, type, expiryDate } = survey;

  const handleFillSurvey = useCallback(() => {
    onFillSurvey(id);
  }, [id, onFillSurvey]);

  return (
    <div className={classes.root}>
      <div className={classes.titleWrapper}>
        <Typography className={classes.title} variant="overline">
          {translations.title.toUpperCase()}
        </Typography>
        <SurveyType type={type} />
      </div>
      <TextBoxWithTooltip
        className={classes.surveyTitle}
        variant="subtitle1"
        text={title}
      />

      <div className={classes.expiryWrapper}>
        <ClockIcon className={classes.clockIcon} />
        <Typography variant="body2">{`${expiryDate}`}</Typography>
      </div>
      <div className={classes.actions}>
        <CustomButton
          className={classes.fillSurveyButton}
          classes={{ label: classes.fillSurveyButtonLabel }}
          customIconWrapper={classes.buttonIcon}
          type="fillSurveySmall"
          onClick={handleFillSurvey}
        >
          {translations.fillSurvey}
        </CustomButton>
      </div>
    </div>
  );
};

FillSurveyCard.propTypes = {
  survey: PropTypes.object,
  onFillSurvey: PropTypes.func.isRequired,
};

export default FillSurveyCard;
